import React from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import withContext from 'components/RealtimeMessagingProvider/withContext'
import { actions as directMessagingActions } from 'store/messaging'
import { selectMyMatchesUnreadCount } from 'store/my-matches-messaging'
import { actions as outreachMessagingActions } from 'store/outreach-messaging'

import MainTabItem from '../../components/MainTabItem'
import { useDirectMessageCount } from './use-direct-message-count'
import { useNotificationCount } from './use-notification-count'
import { useOutreachMessageCount } from './use-outreach-message-count'

const MessageCenterTabItem = ({
  label,
  title,
  userId,
  realtimeConnect,
  unreadDirectMessageCount,
  populateUnreadDirectMessageFlag,
  unreadOutreachMessageCount,
  updateUnreadOutreachMessageCount,
  unreadMyMatchesCount,
  ...rest
}) => {
  const unreadNotificationCount = useNotificationCount(realtimeConnect, userId)
  const directMessageCount = useDirectMessageCount({
    initialValue: unreadDirectMessageCount,
    realtimeConnect,
    userId,
    populateUnreadDirectMessageFlag,
  })
  const outreachMessageCount = useOutreachMessageCount({
    initialValue: unreadOutreachMessageCount,
    realtimeConnect,
    userId,
    updateUnreadOutreachMessageCount,
  })
  // exclude unread my matches messages from the total count
  const totalCount = unreadNotificationCount + directMessageCount + outreachMessageCount

  // only show dot badge for unread my matches messages if there are no other unread messages
  const badgeValue = totalCount > 0 ? totalCount : unreadMyMatchesCount
  const badgeVariant = totalCount > 0 ? 'standard' : 'dot'
  const baseLabel = label?.trim() || title?.trim() || ''
  const computedLabel = badgeValue > 0 ? `${baseLabel} - ${badgeValue} Unread` : baseLabel

  return (
    <MainTabItem
      badgeContent={badgeValue}
      badgeVariant={badgeVariant}
      title={title}
      label={computedLabel}
      {...rest}
    />
  )
}

MessageCenterTabItem.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string.isRequired,
  userId: PropTypes.string,
  realtimeConnect: PropTypes.func,
  populateUnreadDirectMessageFlag: PropTypes.func.isRequired,
  unreadDirectMessageCount: PropTypes.number,
  unreadOutreachMessageCount: PropTypes.number,
  updateUnreadOutreachMessageCount: PropTypes.func.isRequired,
  unreadMyMatchesCount: PropTypes.number,
}

export const MessageCenterTabItemWithContext = withContext({
  connect: 'realtimeConnect',
})(MessageCenterTabItem)

export const ConnectedMessageCenterTabItemWithContext = connect(
  (store) => ({
    userId: store?.user?.record?.Id,
    unreadDirectMessageCount: store?.messaging?.unreadMessageCount,
    unreadOutreachMessageCount: store?.outreachMessaging?.unreadMessageCount,
    unreadMyMatchesCount: selectMyMatchesUnreadCount(store),
  }),
  {
    populateUnreadDirectMessageFlag: directMessagingActions.populateUnreadMessageFlag,
    updateUnreadOutreachMessageCount: outreachMessagingActions.updateUnreadMessageCount,
  },
)(MessageCenterTabItemWithContext)

export default withRouter(ConnectedMessageCenterTabItemWithContext)
